import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

export default function useHomeNavigation() {
    const [crumbs, setCrumbs] = useState([]);

    const lastName = useSelector(state => state.app.loggedInUser.lastName);

    useEffect(
        () => {
            const crumbs = [
                {
                    displayString: `Welcome back, Coach ${
                        lastName ? lastName : ''
                    }!`,
                    link: `/`,
                    editable: false
                }
            ];
            setCrumbs(crumbs);
        },
        [lastName]
    );

    return {
        crumbs
    };
}



// WEBPACK FOOTER //
// ./src/v5/home/components/hooks/useHomeNavigation.js